import React from 'react';

export const indemnityMessages = {
  value: 'Indemnity',
  list: [
    {
      value: (
        <>
          All users agree to indemnify and hold harmless Glints and its
          associated companies, officers, directors, employees, agents,
          proprietors, partners, representatives, shareholders, servants,
          attorneys, predecessors, successors and assigns from and against any
          claims, actions, demands, injuries, liabilities, losses, damages,
          costs and expenses (including legal fees and litigation expenses on a
          full indemnity basis) arising from or relating to the users’ use of
          the Site or its contents or the users’ breach of the Terms and
          Conditions, to the fullest extent permitted by applicable law. This
          indemnification shall be in addition to all other obligations of users
          under the Terms and Conditions, and shall not prejudice any other
          rights or remedies available at law to Glints.
        </>
      ),
    },
  ],
};
